<template>
    <div>
        <div ref="mappingTrendChart" style="height: 350px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart: null,
            }
        },
        mounted () {
            this.createChart();
        },
        methods : {
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                let chart = am4core.create(this.$refs.mappingTrendChart, am4charts.XYChart);

                // Add data
                chart.data = [{
                "country": "K0040",
                "visits": 2025
                }, {
                "country": "K0041",
                "visits": 1882
                }, {
                "country": "K0042",
                "visits": 1809
                }, {
                "country": "K0043",
                "visits": 1322
                }, {
                "country": "K0044",
                "visits": 1122
                }, {
                "country": "Others",
                "visits": 1114
                }];

                // Create axes

                let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "country";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 30;

                categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
                if (target.dataItem && target.dataItem.index & 2 == 2) {
                    return dy + 25;
                }
                return dy;
                });

                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                // Create series
                let series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "visits";
                series.dataFields.categoryX = "country";
                series.name = "Visits";
                series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                series.columns.template.fillOpacity = .8;

                let columnTemplate = series.columns.template;
                columnTemplate.strokeWidth = 2;
                columnTemplate.strokeOpacity = 1;

            }
        }
    }
</script>